import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Games from "@/pages/Games";
import PaymentSuccess from "@/pages/PaymentSuccess";

function App() {
  useEffect(() => {
    document.title = "Scythe Products — AI Vision Models for FPS Games";
  }, []);

  return (
    <div className="App bg-[#0c0d12] min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/games" element={<Games />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
